import React, { useState, useEffect } from "react";
import {
  Box,
  Modal,
  InputBase,
  IconButton,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import { tokens } from "../../theme";
import { getPagosAguinaldoDetails } from "../../services/pagos.services"; 

const ModalPagosAguinaldo = ({ open, onClose, id_usuario, año }) => {
  const [pagosData, setPagosData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const columns = [
    { field: "mes", headerName: "Mes", flex: 1 },
    {
      field: "salario_ips",
      headerName: "Salario IPS",
      flex: 1,
      valueFormatter: (params) =>
        Number(params.value).toLocaleString("es-ES", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
    },
    {
        field: "salario_pagado",
        headerName: "Salario Pagado",
        flex: 1,
        valueFormatter: (params) =>
          Number(params.value).toLocaleString("es-ES", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          }),
      },
    {
      field: "año",
      headerName: "Año",
      flex: 1,
    },
  ];

  useEffect(() => {
    if (!id_usuario || !año) return;
  
    const fetchPagosDetails = async () => {
      try {
        const response = await getPagosAguinaldoDetails(id_usuario, año);
  
        const filteredResponse = response.filter(
          (item) =>
            (item.salario_ips && Number(item.salario_ips) !== 0) ||
            (item.salario_pagado && Number(item.salario_pagado) !== 0) ||
            (item.salario_real && Number(item.salario_real) !== 0)
        );
  
        setPagosData(filteredResponse);
        setFilteredData(filteredResponse);
      } catch (error) {
        console.error("Error fetching pagos aguinaldo details:", error);
        setPagosData([]);
        setFilteredData([]);
      }
    };
  
    fetchPagosDetails();
  }, [id_usuario, año]);

  const handleSearchChange = (event) => {
    const { value } = event.target;
    setSearchValue(value);

    const filtered = pagosData.filter((item) =>
      item.mes.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredData(filtered);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-pagos-aguinaldo-title"
      aria-describedby="modal-pagos-aguinaldo-description"
      style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
      }}
    >
      <Box
        sx={{
          width: 600,
          bgcolor: colors.primary[600],
          p: 3,
          borderRadius: 2,
          boxShadow: 24,
          maxHeight: "80vh",
          overflowY: "auto",
        }}
      >
        <Typography variant="h5" mb={2} color={colors.grey[100]}>
          Detalle de Pagos - Año {año}
        </Typography>

        <Box
          display="flex"
          backgroundColor={colors.primary[400]}
          borderRadius="3px"
          height={40}
          mb={2}
          px={2}
          alignItems="center"
        >
          <InputBase
            sx={{ flex: 1 }}
            placeholder="Buscar por mes"
            value={searchValue}
            onChange={handleSearchChange}
          />
          <IconButton type="button" sx={{ p: 1 }}>
            <SearchIcon />
          </IconButton>
        </Box>

        <Box sx={{ height: 400, width: "100%" }}>
          <DataGrid
            rows={filteredData}
            columns={columns}
            getRowId={(row) => `${row.id_usuario}-${row.mes}-${row.año}`}
            hideFooterSelectedRowCount
            disableSelectionOnClick
          />
        </Box>
      </Box>
    </Modal>
  );
};

export default ModalPagosAguinaldo;